import { Suspense, useMemo } from 'react'

import { abbreviateMoney } from 'src/shared/utils/abbreviate-money'

import TransactionVolumeCardSkeleton from './transaction-volume-card-skeleton'

type TransactionVolumeCardProps = {
  totalVolume: { min: number; max: number }
  totalTransactions: number
}

const TransactionVolumeCardContent = ({ totalVolume, totalTransactions }: TransactionVolumeCardProps) => {
  const totalVolumeText = useMemo(() => {
    if (totalVolume.min === totalVolume.max) {
      return `$${abbreviateMoney(totalVolume.min, 1)}`
    }
    return `$${abbreviateMoney(totalVolume.min, 1)} - $${abbreviateMoney(totalVolume.max, 1)}`
  }, [totalVolume])

  return (
    <div className="flex flex-col gap-3">
      <div className="grid flex-1 grid-cols-1 grid-rows-2 gap-6 rounded-lg border border-border bg-accent px-6 py-4 sm:grid-cols-2 sm:grid-rows-1 sm:gap-1">
        <div className="flex flex-col gap-2">
          <p className="text-base text-muted">Total Volume</p>
          <p className="text-2xl font-bold">{totalVolumeText}</p>
        </div>
        <div className="flex flex-col gap-2">
          <p className="text-base text-muted">Transactions</p>
          <p className="text-2xl font-bold">{totalTransactions}</p>
        </div>
      </div>
    </div>
  )
}

const TransactionVolumeCard = ({ totalVolume, totalTransactions }: TransactionVolumeCardProps) => {
  return (
    <Suspense fallback={<TransactionVolumeCardSkeleton />}>
      <TransactionVolumeCardContent totalVolume={totalVolume} totalTransactions={totalTransactions} />
    </Suspense>
  )
}

export default TransactionVolumeCard
